import React from 'react';
import illustration from '../assets/login-illustration.png';

const LoginIllustration = () => (
  <img
    className="login-split-illustration"
    src={illustration}
    alt=""
    aria-hidden="true"
    draggable={false}
  />
);

export default LoginIllustration;
